import { ContentBlock } from '../interfaces/content-block';
import { DynamicFieldControlFormat, DynamicFieldControlType } from '../types/dynamic-field.type';

export const CONTENT_BUILDER_STYLE = {
  URL: [
    // AppConstant.APP_BASE_URL + '/assets/others/styles.css',
    // AppConstant.APP_BASE_URL + '/assets/others/signature-singpass.css',
    '/assets/others/styles.css',
    '/assets/others/signature-singpass.css',
  ],
  PRINT_OPTIONS: {
    MARGIN: {
      TOP: 60,
      BOTTOM: 60,
      LEFT: 50,
      RIGHT: 50,
    },
  },
};

export class ContentBuilderConstant {
  static contentBlocks: ContentBlock[] = [
    {
      title: 'Components',
      element: [
        {
          type: 'block',
          label: 'Text Field',
          icon: 'text',
          isIconCustom: true,
        },
        {
          type: 'image',
          label: 'Image',
          icon: 'image',
          isIconCustom: true,
        },
        {
          type: 'table',
          label: 'Table',
          icon: 'add-table',
          isIconCustom: true,
        },
        {
          type: 'pageBreak',
          label: 'Page break',
          icon: 'page-break',
          isIconCustom: true,
        },
      ],
      config: {
        expanded: true,
      },
    },
    {
      title: 'Fields',
      element: [
        {
          type: 'singpassToggleButton',
          hidden: true,
        },
        {
          type: 'signatureField',
          label: 'Signature Field',
          icon: 'signature',
          isIconCustom: true,
        },
        {
          type: 'redrInlineTextField',
          label: 'Text Field',
          icon: 'text',
          isIconCustom: true,
        },
        {
          type: 'redrInlineDateField',
          label: 'Date',
          icon: 'calendar_today',
          isIconCustom: false,
        },
      ],
      config: {
        element: {
          backgroundColor: 'orange',
        },
        expanded: true,
      },
    },
  ];

  static controlTypes: { key: DynamicFieldControlType; name: string; format?: DynamicFieldControlFormat }[] = [
    { key: 'textbox', name: 'Character', format: 'string' },
    { key: 'number', name: 'Number', format: 'number' },
    // { key: 'currency', name: 'Currency', format: 'number' },
    { key: 'dropdown', name: 'Dropdown', format: 'string' },
    { key: 'file', name: 'File', format: 'string' },
    { key: 'date', name: 'Date & Time', format: 'date' },
  ];

  static dataTypes: { [x: string]: { key: string; name: string; format?: any }[] } = {
    textbox: [
      { key: 'text', name: 'Text' },
      { key: 'email', name: 'Email' },
      { key: 'url', name: 'Url' },
    ],
    number: [
      {
        key: 'integer',
        name: 'Integer',
        format: {
          decimalLimit: 2,
          includeThousandsSeparator: true,
          integerLimit: 9,
        },
      },
      {
        key: 'percent',
        name: 'Percent',
        format: {
          decimalLimit: 2,
          includeThousandsSeparator: true,
          integerLimit: 9,
          suffix: '%',
        },
      },
    ],
    currency: [
      {
        key: 'singaporeDollar',
        name: 'Singapore dollar (S$)',
        format: {
          decimalLimit: 2,
          includeThousandsSeparator: true,
          integerLimit: 9,
        },
      },
      {
        key: 'unitedStatesDollar',
        name: 'United States dollar ($)',
        format: {
          decimalLimit: 2,
          includeThousandsSeparator: true,
          integerLimit: 9,
        },
      },
    ],
    dropdown: [
      { key: 'tenant', name: 'Tenants' },
      { key: 'item', name: 'Items' },
      { key: 'dropdownManually', name: 'Add New' },
    ],
    file: [{ key: 'image', name: 'Image' }],
    date: [
      // { key: 'longDate', name: 'Long Date', format: 'hh:mm A DD/MM/YYYY' },
      { key: 'shortDate', name: 'Date', format: 'DD/MM/YYYY' },
      { key: 'time', name: 'Time' },
    ],
  };
}
